import { StateManager } from 'AppReact';

let translateTextState = StateManager([
  {
    name: 'detect',
    isRemote: true,
    isSingleton: true,
    defaultValue: [],
    show: (_, { text }) => { return `/api/translate/detect?q=${text}` }
  },
  {
    name: 'translate',
    isRemote: true,
    isSingleton: true,
    defaultValue: [],
    show: (_, { text, target }) => { return `/api/translate?q=${text}&target=${target}` }
  }
])


export const translateText = async (text) => {
  const r = await translateTextState.fetchDetect({ text: encodeURI(text) });
  if (!r.data?.data) return '';
  const language = r.data.data.detections[0][0].language;
  let transLang = '';
  language === 'en' ? transLang = 'es' : transLang = 'en';
  const textResponse = await translateTextState.fetchTranslate({ text: encodeURI(text), target: transLang });
  return textResponse.data.data.translations[0].translatedText;
}